import React from 'react';
import { Stack, Paper } from '@mui/material';
import { VTypography } from '@venti-components';
import PageContainer from '../../../Components/PageContainer/PageContainer';
import VBreadcrumbs from '../../../Venti-UI-Kit/VBreadcrumbs/VBreadcrumbs';
import CustomCircularProgress from '../../../Components/CustomCircularProgress/CustomCircularProgress';
import BackofficePageTitle from '../../../Components/BackofficePageTitle/BackofficePageTitle';
import { useEventPaymentMethodsPage } from './hook';
import PaymentMethodCard from './PaymentMethodCards/PaymentMethodCard';
import LineCommerces from './LineCommerces/LineCommerces';

const EventPaymentMethodsPage = () => {
  const { isLoading, mercadopago, line, dlocal, modoLine, eventName } =
    useEventPaymentMethodsPage();

  if (isLoading) {
    return (
      <PageContainer title="Backoffice - Métodos de Pago">
        <VBreadcrumbs pageTitle="Métodos de Pago" />
        <CustomCircularProgress size={40} />
      </PageContainer>
    );
  }

  return (
    <PageContainer title="Backoffice - Métodos de Pago">
      <VBreadcrumbs pageTitle="Métodos de Pago" />
      <Stack width="100%" alignItems="flex-start" paddingLeft={20} paddingRight={20} gap={3}>
        <BackofficePageTitle mainTitle={eventName} secondaryTitle="Métodos de pago del evento" />
        {!isLoading && (
          <Stack gap={3} alignItems="center" direction="row" flexWrap="wrap">
            <PaymentMethodCard config={mercadopago} name="Mercado Pago" />
            <PaymentMethodCard config={modoLine} name="Modo vía Line" />
            <PaymentMethodCard config={line} name="Line" />
            <PaymentMethodCard config={dlocal} name="dLocal" />
          </Stack>
        )}
        {modoLine?.modoCommerces && (
          <>
            <VTypography variant="subtitle1">Comercios de Line ‧ Modo</VTypography>
            <LineCommerces commerces={modoLine.modoCommerces} />
          </>
        )}
        {line?.lineAvailableCards && (
          <>
            <VTypography variant="subtitle1">Comercios de Line ‧ Tarjetas</VTypography>
            <LineCommerces commerces={line.lineAvailableCards} />
          </>
        )}
        {isLoading && (
          <Paper sx={{ p: 3, borderRadius: 2, width: '100%', maxWidth: 600 }}>
            <VTypography variant="body1" color="textSecondary" align="center">
              No se pudieron cargar los métodos de pago para este evento.
            </VTypography>
          </Paper>
        )}
      </Stack>
    </PageContainer>
  );
};

export default EventPaymentMethodsPage;
